import FormBuilder from '@components/Form';
import Page from '@components/Page';
import { PermissionForm } from '@src/forms/Permissions';
import I18n from '@src/i18n';
import { Button, Checkbox, Col, Modal, Radio, Row } from 'antd';
import React, { Component } from 'react';

import styled from '../styled-components';

const RadioGroup = Radio.Group;

interface IPermissionStateType {
  disabled: boolean,
  iconLoading?: boolean,
  isLoading: boolean,
  showFormModal: boolean,
  value?: number,
  isGroupHelperVisible: boolean,
  isUserHelperVisible: boolean
};

export enum PermissionClasses {
  MAIN_PANEL = 'permission-main-panel',
  SAVE_BTN = 'permission-save-btn',
  SECTION = 'permission-section',
  SECTION_HELPER = "permission-section-helper",
  SECTION_TITLE = 'permission-section-title',
};

export default class Permission extends Component<any, IPermissionStateType> {

  constructor(props: any) {
    super(props);

    this.state = {
      disabled: true,
      isLoading: true,
      showFormModal: false,
      isGroupHelperVisible: true,
      isUserHelperVisible: true,
    };
  }

  toggleDisabled = () => {
    this.setState({
      disabled: !this.state.disabled
    });
  };

  onChange = (e: any) => {
    console.log('radio checked', e.target.value);
    this.setState({
      value: e.target.value,
    });
  }

  toggleFormModal = () => {
    this.setState({
      showFormModal: !this.state.showFormModal,
    });
  }

  onSubmit = async (e: any) => {
    console.log(e);
  }

  render() {
    const {
      showFormModal,
    } = this.state;

    return (
      <Page>
        <Wrapper>
          <h4>{I18n.l("permissions.guide")}</h4>
          <Row className={PermissionClasses.MAIN_PANEL}>
            <Col className={PermissionClasses.SECTION} span={4}>
              <p className={PermissionClasses.SECTION_TITLE}>{I18n.l("permissions.group")}</p>
              <Button className="goepik-btn-border-main" onClick={this.toggleFormModal}>{I18n.l("permissions.createGroupBtn")}</Button>
              <Modal onCancel={this.toggleFormModal} visible={showFormModal} footer={false}>
                <ModalTitle>{I18n.l('permissions.createGroupModal.title')}</ModalTitle>
                <ModalContent>
                  <FormBuilder
                    settings={PermissionForm}
                    onSubmit={this.onSubmit}
                    onCancel={this.toggleFormModal}
                    innerComponent={
                      <div className='goepik-component-padding'>
                        <p style={{ fontWeight: 'bold' }} >{I18n.l("permissions.groupAccess")}</p>
                        <Row>
                          <Col span={12}>
                            <Checkbox onChange={this.toggleDisabled} value="A">
                              <span>{I18n.l("permissions.groupAccess")}</span>
                              <RadioGroup disabled={this.state.disabled} onChange={this.onChange}>
                                <Radio value={1}>{I18n.l("permissions.createGroupModal.readOnly")}</Radio>
                                <Radio value={2}>{I18n.l("permissions.createGroupModal.readWrite")}</Radio>
                              </RadioGroup>
                            </Checkbox>
                          </Col>
                        </Row>
                      </div>
                    }
                  />
                </ModalContent>
              </Modal>
            </Col>
            <Col className={PermissionClasses.SECTION} span={10}>
              <p className={PermissionClasses.SECTION_TITLE}>{I18n.l("permissions.groupAccess")}</p>
              <p className={`${PermissionClasses.SECTION_HELPER} ${!this.state.isGroupHelperVisible ? 'hidden' : ''}`}>{I18n.l("permissions.groupAccessHelper")}</p>
            </Col>
            <Col className={PermissionClasses.SECTION} span={10}>
              <p className={PermissionClasses.SECTION_TITLE}>{I18n.l("permissions.groupUsers")}</p>
              <p className={`${PermissionClasses.SECTION_HELPER} ${!this.state.isUserHelperVisible ? 'hidden' : ''}`}>{I18n.l("permissions.groupUsersHelper")}</p>
            </Col>
          </Row>
          <Button className={PermissionClasses.SAVE_BTN} onClick={this.onSubmit}>{I18n.l("permissions.save")}</Button>
        </Wrapper>
      </Page>
    );
  }
}


const _grey = "#b5b5b5";
const Wrapper = styled.div`
  width: 100%;
  .${PermissionClasses.MAIN_PANEL} {
    display: flex;
    .${PermissionClasses.SECTION} + .${PermissionClasses.SECTION} {
      border-left: 2px solid ${_grey};
      padding-left: 2rem;
    }
  }
  .${PermissionClasses.SAVE_BTN}{
    float: right;
    margin-top: 2rem;
  }
  .${PermissionClasses.SECTION_TITLE} {
    font-weight: bold;
    margin-bottom: 2rem;
  }
  .${PermissionClasses.SECTION_HELPER} {
    color: ${_grey}
  }
  .${PermissionClasses.SECTION_HELPER}.hidden {
    display: none;
  }
`;

const ModalTitle = styled.h3`
  font-size: 22px;
`;

const ModalContent = styled.div`
  width: 100%;

  .form-input-wrapper_phone {
    max-width: 180px;
  }
`;